// extracted by mini-css-extract-plugin
export default {"commentBody":"eG3pJwjPwIEuk80efcQU"};